export default __webpack_public_path__ + "static/media/store-top3.58e64932.jpg";